import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import clsx from 'clsx';
import WorkbookIcon from '@/components/misc/WorkbookIcon';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var ExpandIcon = function ExpandIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M9.23969 8.58L8.63683 9.18283C8.38982 9.42984 8.38982 9.83324 8.63683 10.0848L12.3739 13.8174L9.20112 13.8174C8.84986 13.8174 8.56431 14.1052 8.56431 14.4543L8.56431 15.3041C8.56431 15.6554 8.85211 15.9409 9.20112 15.9409L15.3632 15.9409C15.54 15.9409 15.6986 15.8707 15.8119 15.7528C15.9298 15.635 16 15.4763 16 15.3041L16 9.14204C16 8.79078 15.7122 8.50522 15.3632 8.50522L14.5133 8.50522C14.162 8.50522 13.8765 8.79303 13.8765 9.14204L13.8765 12.3148L10.1416 8.58C9.8901 8.3307 9.4867 8.3307 9.23969 8.58Z",
      fill: "#696C80"
    }), /*#__PURE__*/_jsx("path", {
      d: "M0.188117 0.188142C0.0702696 0.305989 -3.09744e-07 0.464658 -3.02216e-07 0.636896L-3.28656e-08 6.7989C-1.75115e-08 7.15017 0.287804 7.43578 0.636843 7.43578L1.48672 7.43578C1.83798 7.43578 2.12356 7.14791 2.12356 6.7989L2.12356 3.62609L5.8561 7.36548C6.10314 7.61255 6.50879 7.61255 6.75809 7.36548L7.36092 6.76267C7.60796 6.5156 7.60796 6.10995 7.36092 5.86069L3.62607 2.12359L6.79888 2.12359C7.15014 2.12359 7.43572 1.83572 7.43572 1.48677L7.43572 0.636896C7.43572 0.285635 7.14789 2.35294e-05 6.79888 2.35447e-05L0.639094 2.38139e-05C0.460042 0.00233457 0.301402 0.0748567 0.188117 0.188142Z",
      fill: "#696C80"
    })]
  }));
};

ExpandIcon.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const WidgetPreviewContainerDataButton = _ref => {
  let {
    className = '',
    hasErrors = false,
    originFileType = '',
    onEditData,
    onEditDataErrors
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: clsx(styles.container, className),
    children: [hasErrors ? /*#__PURE__*/_jsxs("button", {
      className: styles.errorButton,
      onClick: onEditDataErrors,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.errorIndicator
      }), " Errors"]
    }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsxs("button", {
      className: styles.dataButton,
      onClick: onEditData,
      children: [hasErrors ? /*#__PURE__*/_jsx("span", {
        className: styles.dataButton__errorIndicator,
        onClick: onEditDataErrors
      }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx(WorkbookIcon, {
        defaultIcon: "google-sheets",
        originFileType: originFileType,
        className: styles.sheetIcon
      }), "Edit Data", /*#__PURE__*/_jsx(ExpandIcon, {
        className: styles.expandIcon
      })]
    })]
  });
};

export default WidgetPreviewContainerDataButton;